import { Injectable } from '@angular/core';
import { ICellularCarrierService } from './services';
import { ProxyService } from '../proxy/ProxyService';

@Injectable({
    providedIn: 'root'
})
export class CellularCarrierService implements ICellularCarrierService {
    public static $name: string = 'cellularCarrierService';

    private _carriers: CASLink.Device.Ui.ViewModel.Modules.CellularCarrierViewModel[];

    constructor(
        private proxyService: ProxyService
    ) {
    }

    public getCellularCarriers(): angular.IPromise<CASLink.Device.Ui.ViewModel.Modules.CellularCarrierViewModel[]> {
        if (this._carriers) {
            return Promise.resolve(this._carriers);
        } else {
            return this.initialize();
        }
    }

    private initialize(): angular.IPromise<CASLink.Device.Ui.ViewModel.Modules.CellularCarrierViewModel[]> {
        return this.proxyService.request({
            endPoint: 'cellularCarrier',
            route: 'getCellularCarriers',
        }).asArray<CASLink.Device.Ui.ViewModel.Modules.CellularCarrierViewModel>()
            .then((result: CASLink.Device.Ui.ViewModel.Modules.CellularCarrierViewModel[]) => {
                this._carriers = result;
                return result;
            });
    }
}
